"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.A = exports.Button = exports.ButtonGroup = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var classes_1 = require("../utils/classes");
var icons_1 = __importDefault(require("./icons"));
var ButtonGroup = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(react_1.default.Fragment, null, children));
};
exports.ButtonGroup = ButtonGroup;
var Button = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, iconStart = _a.iconStart, iconEnd = _a.iconEnd, _b = _a.appearance, appearance = _b === void 0 ? 'default' : _b, _c = _a.shape, shape = _c === void 0 ? 'default' : _c, _d = _a.size, size = _d === void 0 ? 'default' : _d, props = __rest(_a, ["children", "className", "disabled", "iconStart", "iconEnd", "appearance", "shape", "size"]);
    return (react_1.default.createElement("button", __assign({ className: classnames_1.default(appearance !== 'minimal' && appearance !== 'minimal-primary' && 'btn', appearance === 'primary' && 'btn-primary', appearance === 'danger' && 'btn-danger', appearance === 'minimal' && 'btn-minimal', appearance === 'minimal-primary' && ['btn-primary', 'btn-minimal'], size === 'compact' && 'btn-compact', size === 'large' && 'btn-large', {
            rounded: shape === 'default',
            'rounded-lg': shape === 'rounded',
            'rounded-none': shape === 'square',
            'rounded-full': shape === 'pill',
        }, classes_1.addClassName('button'), appearance, className), disabled: disabled }, props),
        iconStart && (react_1.default.createElement(icons_1.default, { icon: iconStart, className: "inline-flex mr-4 align-center" })),
        children,
        iconEnd && (react_1.default.createElement(icons_1.default, { icon: iconEnd, className: "inline-flex ml-4 align-center" }))));
};
exports.Button = Button;
var A = function (_a) {
    var className = _a.className, type = _a.type, _b = _a.underLineOnHover, underLineOnHover = _b === void 0 ? false : _b, children = _a.children, props = __rest(_a, ["className", "type", "underLineOnHover", "children"]);
    return (react_1.default.createElement("a", __assign({ className: classnames_1.default('link', {
            'link-default': type === 'default',
            'link-primary': type === 'primary',
            'link-underline-on-hover': underLineOnHover,
        }, className) }, props), children));
};
exports.A = A;
//# sourceMappingURL=buttons.js.map